import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a8a08f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/number-favourite/_number-favourite.scss?vue&type=style&index=0&id=0a8a08f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a08f2",
  null
  
)

export default component.exports